import { createAction } from '@ngrx/store';

export const updateScreen = createAction('[Tela] Atualiza a largura e breakpoint da tela');
